import { AuthActionEnum, IAuthenticateUserAction } from '.';

export const AuthenticateUserAction = () => {
  return {
    type: AuthActionEnum.AuthenticateUser,
    state: { loading: true, login: false, errorMessage: '' },
  } as IAuthenticateUserAction;
};

export const AuthenticateUserSuccessAction = (isLoggedIn: boolean) => {
  return {
    type: AuthActionEnum.AuthenticateUserSuccess,
    state: { loading: false, login: isLoggedIn, errorMessage: '' },
  };
};

export const AuthenticateUserFailureAction = (message: string) => {
  return {
    type: AuthActionEnum.AuthenticateUserFailure,
    state: { loading: false, login: false, errorMessage: message },
  };
};
